import { render, staticRenderFns } from "./NotificacoesHeader.vue?vue&type=template&id=5cc1c31d&scoped=true"
import script from "./NotificacoesHeader.vue?vue&type=script&lang=js"
export * from "./NotificacoesHeader.vue?vue&type=script&lang=js"
import style0 from "./NotificacoesHeader.vue?vue&type=style&index=0&id=5cc1c31d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1c31d",
  null
  
)

export default component.exports